module.exports = __webpack_public_path__ + "img/logoYiAn.15e42a7c.png";